import { render } from "./vehiclewisestockreport.vue?vue&type=template&id=54ea4f39"
import script from "./vehiclewisestockreport.vue?vue&type=script&lang=js"
export * from "./vehiclewisestockreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__